import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="animate-pulse text-slate-500 font-head text-lg">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin")
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-slate-100 p-6 text-center">
        <div className="text-2xl font-head font-bold text-red-700" data-testid="access-denied">
          Access Denied — Administrator Permission Required.
        </div>
        <a href="/dashboard" className="btn-outline">Back to Dashboard</a>
      </div>
    );
  return children;
}
